module.exports = __webpack_public_path__ + "img/p1.d0e9b20b.png";